<template>
	<div>
		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">Complete Registration</h2>
			</div>
		</div>
		<!-- eo main header -->
		<div class="main-section mgt-40">
			<div class="container">

				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />
					<div class="main-card-header">
						<p v-if="!isRegistrationComplete">Your account has been verified. We just need few more details
							before continuing.</p>
						<p v-if="isRegistrationComplete">
							Please visit a branch nearest to you with your documents or
							contact our customer support helpline at +603-8313 8606 & +603-7724 2070 for more information.
						</p>
					</div>
					<form @submit.prevent="onSubmit" novalidate="" autocomplete="off" v-show="!isRegistrationComplete">
						<div class="form-card">
							<div class="form-card-header">
								<h3>Personal Details</h3>
							</div>

							<div class="form-card-forms">
								<div class="row">
									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												Nationality<span class="required">*</span>
											</label>
											<div class="  mb-3">
												<kendo-dropdownlist v-if="NationalityCollection" name='Nationality'
													ref="nationalitydropdownlist" v-validate="'required'"
													class="form-control"
													:class="{'input': true, 'is-danger': errors.has('Nationality') }"
													v-model="vModel.NationalityId" :data-text-field="'Text'"
													:data-value-field="'Id'" v-on:change='onNationalityChange'
													:auto-bind="false" :option-label='"Please Select Nationality"'
													:data-source="NationalityCollection"
													:optionLabelTemplate = "getOptionLabelTemplate('Please Select Nationality')">
												</kendo-dropdownlist>
												<!-- v-on:cascade="onNationalityCascade" -->
												<div v-show="errors.has('Nationality')" class="help is-danger">
													{{ errors.first('Nationality') }}
												</div>
											</div>
										</div>
										<!-- eo form group -->
									</div>
								</div>
								<div class="row">
									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												Full Name<span class="required">*</span>
											</label>
											<input type="text" class="form-control text-uppercase" id="FirstName" name="FirstName"
												autocomplete="off" v-model="vModel.FirstName"
												v-validate="'required|max:50'"
												:class="{'input': true, 'is-danger': errors.has('FirstName') }"
												v-only-uppercase placeholder="Enter First Name" data-vv-as="First Name">
											<div v-show="errors.has('FirstName')" class="help is-danger">
												{{ errors.first('FirstName') }}
											</div>
										</div>
										<!-- eo form group -->
									</div>
									<div class="col-lg-4">
										<div class="form-group">
											<label for="" style="visibility: hidden">
												Last Name
											</label>
											<input type="text" class="form-control text-uppercase" id="LastName"
												name="LastName" autocomplete="off" v-model="vModel.LastName"
												v-validate="'required|max:50'"
												:class="{'input': true, 'is-danger': errors.has('LastName') }"
												v-only-uppercase placeholder="Enter Last Name" data-vv-as="Last Name">
											<div v-show="errors.has('LastName')" class="help is-danger">
												{{ errors.first('LastName') }}
											</div>
										</div>
										<!-- eo form group -->
									</div>
								</div>
								<div class="row">
									<!-- eo col -->
									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												ID Type <span class="required">*</span>
											</label>
											<div class="  mb-3">
												<kendo-dropdownlist name="IdTypeId" ref="IdTypeDropdownList"
													:disabled="vModel.NationalityId?false:true" class="form-control"
													v-validate="'required'" data-vv-as='ID Type'
													:class="{ 'input' : true, 'is-danger': errors.has('IdTypeId')}"
													v-model="vModel.IdTypeId" :data-text-field="'Text'"
													:data-value-field="'Id'" :option-label='"Please Select ID Type"'													
													v-on:change='onIdTypeChange'
													:optionLabelTemplate = "getOptionLabelTemplate('Please Select ID Type')"
													>

												</kendo-dropdownlist>
											</div>
											<div v-show="errors.has('IdTypeId')" class="help is-danger">
												{{errors.first('IdTypeId')}}
											</div>
										</div>
									</div>
									<div class="col-lg-4" v-if="1 == 2">
										<div class="form-group">
											<label for="">
												ID Issuing Country <span class="required">*</span>
											</label>
											<kendo-dropdownlist v-if="CountryCollection" name='IDIssuingCountry'
												v-validate="'required'" class="form-control"
												:class="{'input': true, 'is-danger': errors.has('IDIssuingCountry') }"
												v-model="vModel.IssuedCountryId" :data-text-field="'Text'"
												:data-value-field="'Id'" data-vv-as='ID Issuing Country'
												:auto-bind="true" :option-label='"Please Select Country"'
												:data-source="CountryCollection" ref="IdIssueCountryDropDownList"
												:disabled="disableIdIssueCountry"
												:optionLabelTemplate = "getOptionLabelTemplate('Please Select Country')">
											</kendo-dropdownlist>
											<div v-show="errors.has('IDIssuingCountry')" class="help is-danger">
												{{ errors.first('IDIssuingCountry') }}
											</div>
										</div>
									</div>

									<div class="col-lg-4" v-if="vModel.IdTypeId==1">
										<div class="form-group">
											<label for="">
												ID Number<span class="required">*</span>
											</label>
											<div class="form-row">
												<input type="text" class="form-control" id="IdNumber" name="IdNumber"
													@blur="populateData" autocomplete="off" v-model="vModel.IdNumber"
													data-vv-as='MyKad Number' v-validate="'required|MyKad'"
													:class="{'input': true, 'is-danger': errors.has('IdNumber') }"
													placeholder="Please Enter ID Number" v-mask="'######-##-####'" />
												<div v-show="errors.has('IdNumber')" class="help is-danger">
													{{ errors.first('IdNumber') }}
												</div>
											</div>
										</div>
									</div>
									<div class="col-lg-4" v-else>
										<div class="form-group">
											<label for="">
												ID Number<span class="required">*</span>
											</label>

											<div class="form-row">
												<input type="text" class="form-control text-uppercase" id="IdNumber"
													name="IdNumber" @blur="populateData" autocomplete="off"
													v-model="vModel.IdNumber" data-vv-as='ID Number'
													v-validate="'required'"
													:class="{'input': true, 'is-danger': errors.has('IdNumber') }"
													placeholder="Please Enter ID Number" />
												<div v-show="errors.has('IdNumber')" class="help is-danger">
													{{ errors.first('IdNumber') }}
												</div>
											</div>
										</div>
									</div>

									<div class="col-lg-4" v-if="vModel.IdTypeId && vModel.IdTypeId!='1'">
										<div class="form-group">
											<label for="">
												ID Issuing Date
												<span class="required"
													v-show="selectedIdType && selectedIdType.IsIssueDateMandatory">*</span>
											</label>
											<kendo-datepicker class="form-control" id="IssuedDate" name="IssuedDate"
												v-model="vModel.IssuedDate" :format="'dd/MM/yyyy'" :max="minDate"
												onkeydown="return false;" data-vv-as='ID Issue Date'
												v-validate="selectedIdType.IsIssueDateMandatory ? 'required' : ''"
												:class="{'input': true, 'is-danger': errors.has('IssuedDate') }"
												placeholder="Please Select ID Issuing Date">
											</kendo-datepicker>
											<div v-show="errors.has('IssuedDate')" class="help is-danger">
												{{ errors.first('IssuedDate') }}
											</div>
										</div>
									</div>

									<div class="col-lg-4" v-if="vModel.IdTypeId && !malaDiv && selectedIdType && selectedIdType.IsIdExpiryDateMandatory">
										<div class="form-group">
											<label for="">
												ID Expiry Date
												<span class="required"
													v-show="selectedIdType && selectedIdType.IsIdExpiryDateMandatory">*</span>
											</label>
											<kendo-datepicker class="form-control" id="IdExpiryDate" name="IdExpiryDate"
												v-model="vModel.IdExpiryDate" :format="'dd/MM/yyyy'" :min="minDate"
												onkeydown="return false;" data-vv-as='ID Expiry Date'
												v-validate="selectedIdType.IsIdExpiryDateMandatory ? 'required' : ''"
												:class="{'input': true, 'is-danger': errors.has('IdExpiryDate') }"
												placeholder="Please Select ID Expiry Date">
											</kendo-datepicker>
											<div v-show="errors.has('IdExpiryDate')" class="help is-danger">
												{{ errors.first('IdExpiryDate') }}
											</div>
										</div>
									</div>
									<div class="col-lg-4"
										v-if="vModel.IdTypeId &&  selectedIdType && selectedIdType.RequireVisaExpiry">
										<div class="form-group">
											<label for="">
												Visa Expiry Date
												<span class="required">*</span>
											</label>
											<kendo-datepicker class="form-control" id="VisaExpiryDate"
												name="VisaExpiryDate" v-model="vModel.VisaExpiryDate"
												:format="'dd/MM/yyyy'" :min="minDate" onkeydown="return false;"
												data-vv-as='Visa Expiry Date' v-validate="'required'"
												:class="{'input': true, 'is-danger': errors.has('VisaExpiryDate') }"
												placeholder="Please Select Visa Expiry Date">
											</kendo-datepicker>
											<div v-show="errors.has('VisaExpiryDate')" class="help is-danger">
												{{ errors.first('VisaExpiryDate') }}
											</div>
										</div>
									</div>

									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												Gender<span class="required">*</span>
											</label>
											<div class="mb-3">
												<kendo-dropdownlist v-if="GenderCollection" name='Gender'
													v-validate="'required'" class="form-control"
													:class="{'input': true, 'is-danger': errors.has('Gender') }"
													v-model="vModel.Gender" :data-text-field="'Text'"
													:data-value-field="'Text'" :auto-bind="true"
													:option-label='"Please Select Gender"'
													:data-source="GenderCollection" ref="CustomerGender"
													:optionLabelTemplate = "getOptionLabelTemplate('Please Select Gender')">
												</kendo-dropdownlist>
												<div v-show="errors.has('Gender')" class="help is-danger">
													{{ errors.first('Gender') }}
												</div>
											</div>
										</div>
										<!-- eo form group -->
									</div>

									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												Country of Birth<span class="required">*</span>
											</label>
											<div class="'' mb-3">
												<kendo-dropdownlist v-if="CountryCollection" name='countryClction'
													v-validate="'required'" class="form-control"
													:class="{'input': true, 'is-danger': errors.has('countryClction') }"
													v-model="vModel.CountryOfBirthId" :data-text-field="'Text'"
													:data-value-field="'Id'" data-vv-as='Country of Birth'
													:auto-bind="true" :option-label='"Please Select Country of Birth"'
													:data-source="CountryCollection"
													:optionLabelTemplate = "getOptionLabelTemplate('Please Select Country of Birth')">
												</kendo-dropdownlist>
												<div v-show="errors.has('countryClction')" class="help is-danger">
													{{ errors.first('countryClction') }}
												</div>
											</div>
										</div>
										<!-- eo form group -->
									</div>

									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												Date of Birth<span class="required">*</span>
											</label>

											<div>
												<kendo-datepicker class="form-control" :format="'dd/MM/yyyy'"
													id="dobirth" name="dobirth" onkeydown="return false;"
													v-model="vModel.DateOfBirth" data-vv-as='Date Of Birth'
													v-validate="'required|age'"
													:class="{'input': true, 'is-danger': errors.has('dobirth') }"
													ref="CustomerDateOfBirth" placeholder="Please Select Date of Birth">
												</kendo-datepicker>
											</div>
											<div v-show="errors.has('dobirth')" class="help is-danger">
												{{ errors.first('dobirth') }}
											</div>
										</div>
										<!-- eo form group -->
									</div>
									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												Unit No & Street Address<span class="required">*</span>
											</label>
											<input type="text" class="form-control text-uppercase" id="street" @input="onInput"
												name="Street" autocomplete="off" v-model="vModel.Street"
												v-validate="'required|max:50'"
												:class="{'input': true, 'is-danger': errors.has('Street') }"
												v-only-uppercase placeholder="Please Enter Unit No & Street Address"
												data-vv-as="Address">
											<div v-show="errors.has('Street')" class="help is-danger">
												{{ errors.first('Street') }}
											</div>
										</div>
										<!-- eo form group -->
									</div>
									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												Postcode<span class="required">*</span>
											</label>
											<input type="text" class="form-control" id="PostCode" name="PostCode" @input="onInput"
												v-only-numeric="" autocomplete="off" v-model="vModel.PostCode"
												data-vv-as='Post Code' v-validate="'required|min:5|max:5'"
												:class="{'input': true, 'is-danger': errors.has('PostCode') }"
												v-only-uppercase placeholder="Please Enter Postcode">
											<div v-show="errors.has('PostCode')" class="help is-danger">
												{{ errors.first('PostCode') }}
											</div>
										</div>
										<!-- eo form group -->
									</div>
									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												City<span class="required">*</span>
											</label>
											<input type="text" class="form-control text-uppercase" id="City" name="City" @input="onInput"
												autocomplete="off" v-model="vModel.City" v-validate="'required|max:50'"
												:class="{'input': true, 'is-danger': errors.has('City') }"
												v-only-uppercase placeholder="Please Enter City">
											<div v-show="errors.has('City')" class="help is-danger">
												{{ errors.first('City') }}
											</div>
										</div>
										<!-- eo form group -->
									</div>
									<!-- eo col -->
									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												State<span class="required">*</span>
											</label>
											<div class="'' mb-3">
												<kendo-dropdownlist v-if="StateMalaCollection " name='State' @change="onInput"
													v-validate="'required'" class="form-control" ref="State"
													:class="{'input': true, 'is-danger': errors.has('State') }"
													v-model="vModel.StateId" :data-text-field="'Text'"
													:data-value-field="'Id'" :auto-bind="true"
													:option-label='"Please Select State"'
													:data-source="StateMalaCollection"
													:optionLabelTemplate = "getOptionLabelTemplate('Please Select State')">
												</kendo-dropdownlist>
												<div v-show="errors.has('State')" class="help is-danger">
													{{ errors.first('State') }}
												</div>
											</div>
										</div>
										<!-- eo form group -->
									</div>
									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												Residential Status<span class="required">*</span>
											</label>
											<div class="  mb-3">
												<kendo-dropdownlist v-if="ResidentialStatusCollection"
													ref="residentalDropDownList" :disabled="true"
													name='residentialStatus' v-validate="'required'"
													class="form-control"
													:class="{'input': true, 'is-danger': errors.has('residentialStatus') }"
													v-model="vModel.ResidentialStatusId"
													v-on:change='onResidentalChange' :data-text-field="'Text'"
													:data-value-field="'Id'" data-vv-as='Residential Status'
													:option-label='"Please Select Residential Status"'
													:data-source="ResidentialStatusCollection"
													:optionLabelTemplate = "getOptionLabelTemplate('Please Select Residential Status')">
												</kendo-dropdownlist>
												<div v-show="errors.has('residentialStatus')" class="help is-danger">
													{{ errors.first('residentialStatus') }}
												</div>
											</div>
										</div>
										<!-- eo form group -->
									</div>



								</div>
								<!-- eo row -->
								<div class="row">
									<div class="col-lg-6">
										<b>Mailing Address</b>	<br>
										<b-form-checkbox v-model="vModel.IsSameMailingAddress" name="IsSameMailingAddress" @input="onInput">
										 <b>Same as Registered Address</b>
										</b-form-checkbox>
									</div>
								</div>
								<!-- eo row -->
								<div class="row">
									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												Unit No & Street Address<span class="required">*</span>
											</label>
											<input type="text" class="form-control text-uppercase" id="MailingStreet" :disabled="vModel.IsSameMailingAddress"
												name="MailingStreet" autocomplete="off" v-model="vModel.MailingStreet"
												v-validate="'required|max:50'"
												:class="{'input': true, 'is-danger': errors.has('MailingStreet') }"
												v-only-uppercase placeholder="Please Enter Mailing Street"
												data-vv-as="Mailing Address">
											<div v-show="errors.has('MailingStreet')" class="help is-danger">
												{{ errors.first('MailingStreet') }}
											</div>
										</div>
										<!-- eo form group -->
									</div>
									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												 Postcode<span class="required">*</span>
											</label>
											<input type="text" class="form-control" id="PostCode" name="MailingPostcode" :disabled="vModel.IsSameMailingAddress"
												v-only-numeric="" autocomplete="off" v-model="vModel.MailingPostcode"
												data-vv-as='Mailing Post Code' v-validate="'required|min:5|max:5'"
												:class="{'input': true, 'is-danger': errors.has('MailingPostcode') }"
												v-only-uppercase placeholder="Please Enter Mailing Postcode">
											<div v-show="errors.has('MailingPostcode')" class="help is-danger">
												{{ errors.first('MailingPostcode') }}
											</div>
										</div>
										<!-- eo form group -->
									</div>
									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												 City<span class="required">*</span>
											</label>
											<input type="text" class="form-control text-uppercase" id="MailingCity" name="MailingCity" :disabled="vModel.IsSameMailingAddress"
												autocomplete="off" v-model="vModel.MailingCity" v-validate="'required|max:50'"
												:class="{'input': true, 'is-danger': errors.has('MailingCity') }"
												v-only-uppercase placeholder="Please Enter Mailing City" data-vv-as='Mailing City'>
											<div v-show="errors.has('MailingCity')" class="help is-danger">
												{{ errors.first('MailingCity') }}
											</div>
										</div>
										<!-- eo form group -->
									</div>
									<!-- eo col -->
									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												 State<span class="required">*</span>
											</label>
											<div class="'' mb-3">
												<kendo-dropdownlist v-if="StateMalaCollection " name='MailingStateId' :disabled="vModel.IsSameMailingAddress"
													v-validate="'required'" class="form-control" ref="MailingState"
													:class="{'input': true, 'is-danger': errors.has('MailingStateId') }"
													v-model="vModel.MailingStateId" :data-text-field="'Text'"
													:data-value-field="'Id'" :auto-bind="true"
													:option-label='"Please Select Mailing State"'
													:data-source="StateMalaCollection"
													data-vv-as="Mailing State"
													:optionLabelTemplate = "getOptionLabelTemplate('Please Select Mailing State')">
												</kendo-dropdownlist>
												<div v-show="errors.has('MailingStateId')" class="help is-danger">
													{{ errors.first('MailingStateId') }}
												</div>
											</div>
										</div>
										</div>
										<!-- eo form group -->
								</div>
								<!-- eo row -->

							</div>
							<!-- eo form card forms -->
						</div>
						<!-- eo form card -->

						<div class="form-card">
							<div class="form-card-header">
								<h3>Employer Details</h3>
							</div>

							<div class="form-card-forms">
								<div class="row">
									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												Company Name<span class="required">*</span>
											</label>
											<input type="text" class="form-control text-uppercase" id="CompanyName"
												name="CompanyName" autocomplete="off" v-model="vModel.CompanyName"
												data-vv-as='Company Name' v-validate="'required|max:50'"
												:class="{'input': true, 'is-danger': errors.has('CompanyName') }"
												v-only-uppercase placeholder="Please Enter Company Name">
											<div v-show="errors.has('CompanyName')" class="help is-danger">
												{{ errors.first('CompanyName') }}
											</div>
										</div>
										<!-- eo form group -->
									</div>
									<!-- eo col -->

									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												Occupation<span class="required">*</span>
											</label>
											<div class="  mb-3">
												<kendo-dropdownlist v-if="OccupationCollection" name='Occupation'
													v-validate="'required'" class="form-control"
													:class="{'input': true, 'is-danger': errors.has('Occupation') }"
													v-model="vModel.OccupationId" :data-text-field="'Text'"
													:data-value-field="'Id'" :auto-bind="true"
													:option-label='"Please Select Occupation"'
													:data-source="OccupationCollection"
													v-on:change='onOccupationChange'
													:optionLabelTemplate = "getOptionLabelTemplate('Please Select Occupation')">
												</kendo-dropdownlist>
												<div v-show="errors.has('Occupation')" class="help is-danger">
													{{ errors.first('Occupation') }}
												</div>
											</div>
										</div>
										<!-- eo form group -->
									</div>
									<!-- eo col -->
									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												Sub Occupation
											</label>
											<div class="  mb-3">
												<kendo-dropdownlist ref="SubOccupationDropdownList"
													name='SubOccupationId' class="form-control"
													v-validate="(SubOccupationCollection.length > 0 ? 'required' : '')"
													:class="{'input': true, 'is-danger': errors.has('SubOccupationId') }"
													v-model="vModel.SubOccupationId" :data-text-field="'Text'"
													:data-value-field="'Id'" :auto-bind="true"
													data-vv-as='Sub Occupation'
													:option-label='"Please Select Sub Occupation"'
													v-on:change='onSubOccupationChange'
													:optionLabelTemplate = "getOptionLabelTemplate('Please Select Sub Occupation')">
												</kendo-dropdownlist>
												<div v-show="errors.has('SubOccupationId')" class="help is-danger">
													{{ errors.first('SubOccupationId') }}
												</div>
											</div>
										</div>
										<!-- eo form group -->
									</div>
									<div class="col-lg-4" v-show="(EmploymentLevelCollection.length > 0)">
										<div class="form-group">
											<label for="">
												Employment Level
											</label>
											<div class="  mb-3">
												<kendo-dropdownlist ref="EmploymentLevelDownList"
													v-validate="(EmploymentLevelCollection.length > 0 ? 'required' : '')"
													name='EmploymentLevelId' class="form-control"
													:class="{'input': true, 'is-danger': errors.has('EmploymentLevelId') }"
													v-model="vModel.EmploymentLevelId" :data-text-field="'Text'"
													:data-value-field="'Id'" data-vv-as='Employment Level'
													:option-label='"Please Select Employment Level"'
													:optionLabelTemplate = "getOptionLabelTemplate('Please Select Employment Level')">
												</kendo-dropdownlist>
												<div v-show="errors.has('EmploymentLevelId')" class="help is-danger">
													{{ errors.first('EmploymentLevelId') }}
												</div>
											</div>
										</div>
										<!-- eo form group -->
									</div>
									<div class="col-sm-4">
										<div class="form-group">
											<label for="JobTitle">
												Job Title<span class="required">*</span>
											</label>
											<input type="text" class="form-control text-uppercase" id="JobTitle"
												data-vv-name="JobTitle" autocomplete="off" v-model="vModel.JobTitle"
												data-vv-as='Job Title' v-validate="'required|max:50'"
												:class="{'input': true, 'is-danger': errors.has('JobTitle') }"
												v-only-uppercase placeholder="Please Enter Job Title">
											<div v-if="errors.has('JobTitle')" class="help is-danger">
												{{ errors.first('JobTitle') }}
											</div>
										</div>
									</div>

									<div class="col-lg-4">
										<div class="form-group">
											<label for="">
												Average Monthly Salary<span class="required">*</span>
											</label>
											<input type="text" class="form-control" id="salary" name="salary"
												v-only-numeric="" maxlength="10" autocomplete="off"
												v-model="vModel.MonthlySalary" data-vv-as='Average Monthly Salary'
												v-validate="'required|min_value:100'"
												:class="{'input': true, 'is-danger': errors.has('salary') }"
												placeholder="Please Enter Average Monthly Salary">
											<div v-show="errors.has('salary')" class="help is-danger">
												{{ errors.first('salary') }}
											</div>
										</div>
									</div>

								</div>
								<!-- eo row -->

							</div>
						</div>
						<!-- eo form card -->

						<div class="form-card">
							<div class="form-card-header">
								<h3>Loyality Points</h3>
							</div>

							<div class="form-card-forms">

								<div class="form-group" v-if="1==2">

									<label for="">
										BonusLink Number (Optional)
									</label>
									<div class="row">
										<div class="col-lg-4">
											<div class=" ">
												<input type="text" class="form-control" name="BonuslinkCardNumber"
													autocomplete="off" v-model="vModel.BonuslinkCardNumber"
													v-validate="'validateBonusLink'"
													:class="{'input': true, 'is-danger': errors.has('BonuslinkCardNumber') }"
													placeholder="Please Enter BonusLink Number">

											</div>
											<div v-show="errors.has('BonuslinkCardNumber')" class="help is-danger">
												{{ errors.first('BonuslinkCardNumber') }}
											</div>
										</div>

										<div class="col-lg-6">
											<a target="_blank"
												href="http://www.bonuslink.com.my/EN/MemberApplication.aspx"
												class="btn btn-link bonus-link">Register
												BonusLink</a>
										</div>
									</div>
								</div>
								<div class="form-group">
									<label for="">
										MyWU Number(Optional)
									</label>
									<div class="row">

										<div class="col-lg-4">
											<div class=" ">
												<input type="text" id="WUNumber" name="WUNumber" :disabled="!canEnterWU"
													autocomplete="off" placeholder="Please Enter MyWU Number"
													v-model="vModel.WUNumber" data-vv-as='WU Number'
													:class="{'input': true, 'is-danger': errors.has('WUNumber') ,'form-control' : true}"
													v-only-uppercase />
											</div>
											<div v-show="errors.has('WUNumber')" class="help is-danger">
												{{ errors.first('WUNumber') }}
											</div>
										</div>

										<div class="col-lg-3">
											<button class="btn btn-red-outline-secondary" type="button"
												id="button-addon2" :disabled="!canEnterWU"
												@click="validateWUNumber">Verify</button>
										</div>




									</div>
								</div>
							</div>
							<!-- eo form card forms -->
						</div>
						<div class="submit-option">
							<div class="right-option">
								<button class="btn submit-righticon-btn">
									<span class="btn-content">Submit</span>
									<span class="right-icon">
										<i class="fas fa-angle-right"></i>
									</span>
								</button>
							</div>
						</div>
					</form>
				</div>
				<!-- eo main card -->

			</div>
			<!-- eo container -->
		</div>
		<!-- eo main section -->
	</div>
</template>
<script>
	import Vue from "vue";
	import Base from "../../shared/Base.vue";
	import Action from "../../shared/Action.vue";
	import Mode from "../../shared/Mode.vue";
	import kendo from "@progress/kendo-ui";
	import ListService from "../../services/list";
	import CommonService from "../../services/common";

	import { vueinstance } from "../../main";
	import VueMask from "v-mask";
	Vue.use(VueMask);

	export default {
		name: "registrationnew",
		extends: Base,
		components: {
			Action,
			Mode
		},
		computed: {
			canEnterWU() {
				return this.vModel.IdTypeId && this.vModel.IdNumber && this.vModel.FirstName && this.vModel.LastName;
			}
		},
		created() {
			this.url.init = "account/completeregistration";
			this.url.update = "account/register/complete";
			this.vModel.DateOfBirth = `${CommonService.getDay()}/${CommonService.getMonth()}/1970`;
		},
		beforeRouteEnter(to, from, next) {
			var promises = [];
			promises.push(ListService.getRegistrationInitComplete());
			Promise.all(promises).then(response => {
				next(p => {
					p.NationalityCollection = response[0].body.NationalityList;
					p.GenderCollection = response[0].body.GenderList;
					p.CountryCollection = response[0].body.CountryList;
					p.StateMalaCollection = response[0].body.StateList;
					p.OfficeStateMalCollection = response[0].body.StateList;
					p.OccupationCollection = response[0].body.Occupations;
					p.ResidentialStatusCollection = response[0].body.ResidentialStatusList;
					p.IdTypeCollection = response[0].body.IdTypeList;
				});
			});
		},

		data() {
			return {
				minDate: new Date(),
				NationalityCollection: "",
				GenderCollection: "",
				StateMalaCollection: "",
				OfficeStateMalCollection: "",
				OccupationCollection: "",
				SubOccupationCollection: [],
				EmploymentLevelCollection: [],
				ResidentialStatusCollection: "",
				IdTypeCollection: [],
				vModel: getDefaultData(),
				malaDiv: false,
				kadDiv: false,
				nonMalaDiv: false,
				isRegistrationComplete: false,
				selectedIdType: null,
				disableIdIssueCountry: false,

			};
		},
		methods: {
			validateWUNumber() {

				if (this.vModel.WUNumber) {
					var req = {
						FirstName: this.vModel.FirstName,
						LastName: this.vModel.LastName,
						IdType: this.selectedIdType.WUCode,
						IdNumber: this.vModel.IdNumber,
						WUNumber: this.vModel.WUNumber
					};
					this.$http.post("westernunion/card/verify", req).then(res => {
						this.$toastr("success", "WU Number is valid.");
					});
				}
			},
			pascalCase: function (str) {
				return str.replace(/(\w)(\w*)/g, function (g0, g1, g2) {
					return g1.toUpperCase() + g2.toLowerCase();
				});
			},

			populateData: function () {
				
				if (this.vModel.IdTypeId == 1) {
					var self = this;
					let idNumber = "";

					if (self.vModel.IdNumber) {
						let splitIdnumber = [];
						splitIdnumber = self.vModel.IdNumber.split("-");
						if (splitIdnumber.length == 3) {
							idNumber = splitIdnumber.join("");
						}
					}


					var CustomerDateOfBirth = self.$refs.CustomerDateOfBirth.kendoWidget();
					var CustomerGender = self.$refs.CustomerGender.kendoWidget();

					self.vModel.Gender = null;
					self.vModel.DateOfBirth = null;

					CustomerGender.value(null);
					CustomerDateOfBirth.value(null);

					// var respone = CommonService.validateMyKad(self.vModel.IdNumber);
					var response = CommonService.validateMyKad(idNumber);
					if (response.gender != null) {
						self.vModel.Gender = self.pascalCase(response.gender);
						CustomerGender.value(self.vModel.Gender);
					}

					if (response.dateofbirth != null) {
						self.vModel.DateOfBirth = response.dateofbirth;
						CustomerDateOfBirth.value(self.vModel.DateOfBirth);
					}
				}
			},
			onSubmit: function () {
				var self = this;
				if (self.isProcessing) return false;
				self.$validator.validateAll().then(result => {
					if (result && self.beforeSave()) {
						self.isProcessing = true;
						ga('send', 'event', 'Button', 'Click', 'Submit');
						var cloneModel = Object.assign({}, self.vModel);
						cloneModel.DateOfBirth = CommonService.ToYYYYMMDD(
							cloneModel.DateOfBirth
						);
						cloneModel.VisaExpiryDate = CommonService.ToYYYYMMDD(
							cloneModel.VisaExpiryDate
						);
						cloneModel.IssuedDate = CommonService.ToYYYYMMDD(
							cloneModel.IssuedDate
						);
						cloneModel.IdExpiryDate = CommonService.ToYYYYMMDD(
							cloneModel.IdExpiryDate
						);

						//   cloneModel.PassportExpiryDate = CommonService.ToYYYYMMDD(
						//     cloneModel.PassportExpiryDate
						//   );

						self.$http.post(self.url.update, cloneModel).then(
							response => {
								self.$toastr("success", "Saved Successfully");
								self.isProcessing = false;
								self.isRegistrationComplete = true;
								CommonService.setStorage("userDetail",
									JSON.stringify(response.data)
								);
								CommonService.setStorage("completeRegistration", "true");
								//UPDATE ADDRESS VALIDATION
								self.AddressValidationCheck = {
									IsValid: true,
									DisplayMessage: ''
								}
								CommonService.setStorage('addressValidation', JSON.stringify(self.AddressValidationCheck));
								//
								setTimeout(function () {
									self.$router.push("/dashboard");
								}, 2000);
							},
							error => {
								self.isProcessing = false;
							}
						);
					}
				});
			},
			onClearForm: function () {
				this.vModel = getDefaultData();
				this.errors.clear();
			},
			onNationalityChange: function (e) {
				this.vModel.IdTypeId = null;
				var nationalityDropDownList = this.$refs.nationalitydropdownlist.kendoWidget();
				var nationalitydropdownValue = nationalityDropDownList.value();
				this.$refs.IdTypeDropdownList.kendoWidget().setDataSource(
					this.IdTypeCollection.filter(
						x =>
							x.ResidentialStatus === (nationalitydropdownValue === "111" ? 2 : 1)
					)
				);

				if (nationalitydropdownValue == 111) {
					this.$refs.residentalDropDownList.kendoWidget().select(2);
					this.vModel.ResidentialStatusId = 2;
					this.kadDiv = true;
					this.malaDiv = true;
					this.nonMalaDiv = false;
				} else {
					this.$refs.residentalDropDownList.kendoWidget().select(1);
					this.vModel.ResidentialStatusId = 1;
					this.kadDiv = false;
					this.nonMalaDiv = true;
					this.malaDiv = false;
					//this.vModel.MyKad = null;
				}
			},
			onIdTypeChange: function (e) {
				var selectedIndex = e.sender.select();
				this.selectedIdType = e.sender.dataItem(selectedIndex);
				this.vModel.VisaExpiryDate = "";
				this.vModel.IssuedDate = "";
				this.vModel.IdExpiryDate = "";

				// setTimeout(() => {
				// 	if (this.selectedIdType) {

				// 		var index = this.CountryCollection.findIndex(x => x.Id == this.selectedIdType.DefaultIdIssueCountryId);

				// 		this.$refs.IdIssueCountryDropDownList.kendoWidget().select(index + 1);
				// 		this.vModel.IssuedCountryId = this.selectedIdType.DefaultIdIssueCountryId;
				// 		if (this.selectedIdType.DefaultIdIssueCountryId)
				// 			this.disableIdIssueCountry = true;
				// 		else
				// 			this.disableIdIssueCountry = false;


				// 	}
				// }, 500);
			},
			onResidentalChange: function (e) {
				var residentalDropDownList = this.$refs.residentalDropDownList.kendoWidget();
				var residentalDropDownValue = residentalDropDownList.value();
				if (residentalDropDownValue == 1) {
					this.nonMalaDiv = true;
					this.malaDiv = false;
					this.clearNonMalaysianDiv();
				} else {
					this.malaDiv = true;
					this.nonMalaDiv = false;
					this.clearMalaysianDiv();
				}
			},

			clearMalaysianDiv() {
				//this.vModel.PassportNo = null;
				//this.vModel.PassportExpiryDate = null;
				//this.vModel.VisaExpiryDate = null;
				this.vModel.CompanyName = null;
				this.vModel.JobTitle = null;
				this.vModel.OfficeNo = null;
				this.vModel.OfficeAddress = null;
			},
			clearNonMalaysianDiv() {
				this.vModel.CompnameMal = null;
				this.vModel.JobTitleMal = null;
				this.vModel.OfficeNoMal = null;
				this.vModel.OfficeStreetMal = null;
				this.vModel.OfficeCityMal = null;
				this.vModel.OfficeCityMal = null;
				this.vModel.OfficeStateMal = null;
				this.vModel.OfficePostCodeMal = null;
			},
			kadInput: function (sValue) {
				if (sValue.length == 12) {
					var lastDigit = sValue.substring(10, 12);
					this.vModel.Gender = lastDigit % 2 == 0 ? 2 : 1;
				}
			},
			onOccupationChange(e) {
				this.vModel.SubOccupationId = null;
				this.vModel.EmploymentLevelId = null;
				this.SubOccupationCollection = [];
				this.EmploymentLevelCollection = [];


				this.$refs.EmploymentLevelDownList.kendoWidget().setDataSource([]);
				this.$refs.EmploymentLevelDownList.kendoWidget().value(this.vModel.EmploymentLevelId);
				if (e.sender.value()) {
					this.SubOccupationCollection = e.sender.dataSource.view()[e.sender.selectedIndex - 1].SubOccupations.map(function (m) {
						return {
							Id: m.Id,
							Text: m.Text,
							EmploymentLevel: m.EmployeementLevels
						}
					});
					this.$refs.SubOccupationDropdownList.kendoWidget().setDataSource(this.SubOccupationCollection);

				}
				else {
					this.$refs.SubOccupationDropdownList.kendoWidget().setDataSource([]);
					this.$refs.SubOccupationDropdownList.kendoWidget().value(this.vModel.SubOccupationId);
				}
				// this.vModel.EmploymentLevelId = null;
				// this.vModel.SubOccupationId = null;
				// this.SubOccupationCollection = null;
				// this.EmploymentLevelCollection = null;

				// setTimeout(() => {

				// if (e.sender.value()) {
				// 	var occupation = this.OccupationCollection.find(x => {
				// 	return x.Id == e.sender.value();
				// 	});
				// 	if (occupation != null && occupation.SubOccupation.length > 0)
				//   		this.SubOccupationCollection = occupation.SubOccupation;
				// }
				// }, 100);
			},
			onSubOccupationChange(e) {

				this.vModel.EmploymentLevelId = null;
				this.EmploymentLevelCollection = [];

				if (e.sender.value()) {
					this.EmploymentLevelCollection = e.sender.dataSource.view()[e.sender.selectedIndex - 1].EmploymentLevel.map(function (m) {
						return {
							Id: m.Id,
							Text: m.Text,
							DefaultValue: m.DefaultValue
						}
					})
					this.$refs.EmploymentLevelDownList.kendoWidget().setDataSource(this.EmploymentLevelCollection);

					if (this.EmploymentLevelCollection.length > 0) {

						var defaultValue = this.EmploymentLevelCollection.filter((s) => { return s.DefaultValue; })[0];
						if (defaultValue) {
							this.vModel.EmploymentLevelId = defaultValue.Id;
							this.$refs.EmploymentLevelDownList.kendoWidget().value(this.vModel.EmploymentLevelId);
						}

					}
				} else {
					this.$refs.EmploymentLevelDownList.kendoWidget().setDataSource([]);
					this.$refs.EmploymentLevelDownList.kendoWidget().value(this.vModel.EmploymentLevelId);
				}
			},

			getOptionLabelTemplate: function(option){
				return '<span class="drop-option">'+option+'</span>';
			},

			onInput(){
				if(this.vModel.IsSameMailingAddress){
					this.vModel.MailingStreet = this.vModel.Street;
					this.vModel.MailingPostcode = this.vModel.PostCode;
					this.vModel.MailingCity = this.vModel.City;
					var stateId = this.$refs.State.kendoWidget().value();
					this.$refs.MailingState.kendoWidget().value(stateId);					
					this.vModel.MailingStateId = stateId;
				}else {
					this.vModel.MailingStreet = '',
					this.vModel.MailingPostcode = '';
					this.vModel.MailingCity = '';
					this.vModel.MailingStateId = '';
				}
			}
		}
	};
	function getDefaultData() {
		return {
			BonuslinkCardNumber: "",
			NationalityId: null,
			IdTypeId: null,
			IssuedCountryId: null,
			IdNumber: "",
			IssuedDate: "",
			IdExpiryDate: "",
			//MyKad: "",
			Gender: "",
			DateOfBirth: "",
			CountryOfBirthId: null,
			Street: "",
			StateId: null,
			PostCode: "",
			City: "",
			OccupationId: null,
			SubOccupationId: null,
			EmploymentLevelId: null,
			OtherOccupation: null,
			MonthlySalary: "",
			ResidentialStatusId: null,
			CompnameMal: "",
			JobTitleMal: "",
			OfficeNoMal: "",
			OfficeCityMal: "",
			OfficeStateMalId: null,
			OfficeStreetMal: "",
			OfficePostCodeMal: "",
			CompanyName: "",
			//PassportNo: "",
			//PassportExpiryDate: "",
			VisaExpiryDate: "",
			JobTitle: "",
			OfficeNo: "",
			OfficeAddress: "",
			WUNumber: "",
			FirstName: '',
			LastName: '',
			IsSameMailingAddress: false,
			MailingStreet: '',
			MailingPostcode: '',
			MailingCity: '',
			MailingStateId: null
		};
	}
</script>

<style scoped>
	 .mb-3 .is-danger {
		width: 100%;
	}

	input[type="text"]::placeholder {
		/* Chrome, Firefox, Opera, Safari 10.1+ */
		text-transform: capitalize !important;
	}

	:-ms-input-placeholder {
		/* Internet Explorer 10-11 */
		text-transform: capitalize !important;
	}

	::-ms-input-placeholder {
		/* Microsoft Edge */
		text-transform: capitalize !important;
	}
	
</style>
